"use client";
import InpSafeForm from "@/components/atoms/FormComponents/InpSafeForm";

import { Controller } from "react-hook-form";
import Input from "@/revamp/sections/HomeNewFaq/Input/Input";
import styles from "./HomeConnectModalFormNew.module.scss";
import cn from "clsx";
import SubmitButton from "@/components/atoms/FormComponents/SubmitButton";
import Checkbox from "@/components/atoms/FormComponents/Checkbox";
import SelectDark from "@/revamp/atoms/FormComponents/Select/SelectDark";
import CountryDropdownGlobal from "@/revamp/sections/HomeNewFaq/CustomDropdownGlobal/CustomDropdownGlobal";
import customStyles from "@/revamp/atoms/FormComponents/Select/customStyles.module.scss";
import ConsentFormParaIConsent from "@/components/common/utils/consentFormParaIConsent";
import { useHomeConnectModalFormNewController } from "./controller/useHomeConnectModalFormNewController";
import type { HomeConnectModalFormNewProps } from "./model/homeConnectModalFormNew.types";

const HomeConnectModalFormNew = (props: HomeConnectModalFormNewProps) => {
  const {
    control,
    errors,
    isSubmitting,
    isOTPLoading,
    programsList,
    showProgramField,
    isProgram,
    isProgramListPage,
    isMobile,
    isSpecificPage,
    isFaq,
    isSeatsFilled,
    seatsFilled,
    showStatsCards,
    landingPageValue,
    countries,
    isAccaPage,
    handleFieldChange,
    handleDegreeChange,
    handleProgramChange,
    handleFieldBlur,
    updateCountryCode,
    handleFormSubmit,
    degreeOptions,
    SELECT_DEGREE,
    SELECT_PROGRAM,
  } = useHomeConnectModalFormNewController(props);

  return (
    <>
      <InpSafeForm
        onSubmit={handleFormSubmit}
        className={cn(
          styles.root,
          "lining-nums",
          isProgramListPage && styles.programListForm,
        )}
      >
        {/* name */}
        <div className={cn(styles.inputWrapper)}>
          <Controller
            name="fullName"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <Input
                  placeholder="Full Name"
                  value={field.value ?? ""}
                  onChangeFunc={(value: string) =>
                    handleFieldChange("fullName", value)
                  }
                  onBlur={() => {
                    field.onBlur();
                    handleFieldBlur(
                      "fullName",
                      field.value,
                      fieldState.error?.message || "",
                    );
                  }}
                  id="full_name"
                />
                <p className={cn(styles.error)}>
                  {fieldState.error?.message ?? errors.fullName}
                </p>
              </>
            )}
          />
        </div>
        {/* phone with code */}
        <div className={cn(styles.inputWrapper)}>
          <div className={styles.dropdown}>
            <div>
              <Controller
                name="countryCode"
                control={control}
                render={({ field }) => (
                  <CountryDropdownGlobal
                    countries={countries}
                    countryCode={field.value}
                    updateCountryCode={updateCountryCode}
                    additionalStyle={styles.text_field}
                    isDark={false}
                    isSpecificPage={isSpecificPage}
                    disabled={isProgramListPage}
                  />
                )}
              />
            </div>
            <div className="w-full">
              <Controller
                name="phoneNumber"
                control={control}
                render={({ field, fieldState }) => (
                  <Input
                    placeholder="Mobile No."
                    value={field.value ?? ""}
                    onChangeFunc={(value: string) =>
                      handleFieldChange("phoneNumber", value)
                    }
                    onBlur={() => {
                      field.onBlur();
                      handleFieldBlur(
                        "phoneNumber",
                        field.value,
                        fieldState.error?.message || "",
                      );
                    }}
                    id="enter_phone_no"
                    isTel
                  />
                )}
              />
            </div>
          </div>
          <p className={cn(styles.error)}>
            {errors.countryCode || errors.phoneNumber}
          </p>
        </div>
        {/* Email */}
        <div className={cn(styles.inputWrapper)}>
          <Controller
            name="emailId"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <Input
                  placeholder="Email Address"
                  value={field.value ?? ""}
                  onChangeFunc={(value: string) =>
                    handleFieldChange("emailId", value)
                  }
                  onBlur={() => {
                    field.onBlur();
                    handleFieldBlur(
                      "emailId",
                      field.value,
                      fieldState.error?.message || "",
                    );
                  }}
                  id="email_id"
                />
                <p className={cn(styles.error)}>
                  {fieldState.error?.message ?? errors.emailId}
                </p>
              </>
            )}
          />
        </div>
        {/* Degree */}
        {showProgramField && (
          <div className={cn(styles.inputWrapper)}>
            <Controller
              name="degree"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <SelectDark
                    value={field.value}
                    onChangeFunc={handleDegreeChange}
                    options={
                      !!landingPageValue
                        ? [landingPageValue]
                        : [SELECT_DEGREE, ...degreeOptions]
                    }
                    id="degree_lookup"
                    customStyles={customStyles}
                    isProgramListPage={isProgramListPage}
                    disabled={!!landingPageValue}
                  />
                  <p className={cn(styles.error)}>
                    {fieldState.error?.message ?? errors.degree}
                  </p>
                </>
              )}
            />
          </div>
        )}
        {/* Program */}
        {showProgramField && (
          <div className={cn(styles.inputWrapper, "w-full")}>
            <Controller
              name="program"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <SelectDark
                    value={field.value}
                    onChangeFunc={handleProgramChange}
                    options={[SELECT_PROGRAM, ...programsList]}
                    id="program_lookup"
                    customStyles={customStyles}
                    isProgramListPage={isProgramListPage}
                  />
                  <p className={cn(styles.error)}>
                    {fieldState.error?.message ?? errors.program}
                  </p>
                </>
              )}
            />
          </div>
        )}
        <div className={styles.commonMargins}>
          <div className="shrink-0">
            <Controller
              name="isTermsAccepted"
              control={control}
              render={({ field, fieldState }) => (
                <Checkbox
                  name="consent"
                  value={field.value}
                  onChangeFunc={(value: boolean) =>
                    handleFieldChange("isTermsAccepted", value)
                  }
                  onBlur={() => {
                    field.onBlur();
                    handleFieldBlur(
                      "isTermsAccepted",
                      "",
                      fieldState.error?.message || "",
                    );
                  }}
                  style={
                    isProgramListPage
                      ? {
                          padding: "7px",
                          width: "auto",
                          height: "auto",
                          transform: "none",
                        }
                      : {}
                  }
                />
              )}
            />
          </div>
            <p className={styles.authorization}>
              By entering these details I agree that Amity University Online and
              its associates can contact me with updates & notifications via
              Email, SMS, WhatsApp, and Voice call as per its{" "}
              <a
                href="https://amityonline.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "underline",
                  textDecorationColor: "inherit",
                  cursor: "pointer",
                }}
              >
                Privacy Policy
              </a>
              . This consent will override any registration for DNC / NDNC.
            </p>
          <p className={cn(styles.termserror)}>{errors.isTermsAccepted}</p>
        </div>
        <SubmitButton
          text={
            isSubmitting || isOTPLoading
              ? "Submitting..."
              : isProgramListPage
                ? "Submit"
                : "Get Free Counselling"
          }
          isLoading={isSubmitting || isOTPLoading}
          isDisabled={isSubmitting || isOTPLoading}
        />
      </InpSafeForm>
      {isSeatsFilled ? (
        <div
          className={cn(
            styles.filled_seat_container,
            `${isFaq ? "mt-[1.2rem]" : "mt-5"}`,
          )}
        >
          <div
            className={cn(styles.filled_seats, "w-[72%]")}
            style={
              {
                "--progress": (seatsFilled ?? 0) / 100,
              } as React.CSSProperties
            }
          >
            <div className={styles.filled}></div>
          </div>
          <div className={cn("w-[40%] lg:w-[21%] text-end", styles.text)}>
            {seatsFilled}% Seats filled
          </div>
        </div>
      ) : null}

      {(showStatsCards || !isProgram) && (
        <div className={styles.cards}>
          <div className={styles.card}>
            <p className={styles.bold}>250,000+</p>
            <p>Learner Community</p>
          </div>

          <div className={styles.divider}></div>

          <div className={styles.card}>
            <p className={styles.bold}>100%</p>
            <p>Placement Assistance</p>
          </div>

          <div className={styles.divider}></div>

          <div className={styles.card}>
            <p className={styles.bold}>450+</p>
            <p>Hiring Partners</p>
          </div>
        </div>
      )}
    </>
  );
};

export default HomeConnectModalFormNew;
